// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-list-currency-selector__sub{display:block;font-family:var(--number-font)}.h-list-currency-selector__sub__base,.h-list-currency-selector__sub__calc{display:inline-block}.h-list-currency-selector__sub__calc__divider{margin:0 .5em}", ""]);
// Exports
module.exports = exports;
